import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper";
import * as constand from "../../constant.js";
import { loginModelOpen } from "../../actions/HeaderActions";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min.js";

const MyProgrammeAccordian = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { programList, key, condition } = props;

  // Function to get slidesPerView based on screen width
  const getSlidesPerView = () => {
    if (window.innerWidth >= 1000) {
      return 4;
    } else if (window.innerWidth >= 768) {
      return 2.5;
    } else {
      return 1.5;
    }
  };

  // Check if navigation should be shown
  const shouldShowNavigation = () => {
    return window.innerWidth >= 1050 && programList.length > getSlidesPerView();
  };

  function navigateToProgram(program) {
    const user = localStorage.getItem("user");

    if (!user) {
      dispatch(loginModelOpen(true));
      return;
    }

    if (program.isDynamic) {
      history.push(`/programmes/dashboard/${condition}/${program.id}`);
    } else {
      history.push(`/programmes/detail/${condition}/${program.id}`);
    }
  }
  return (
    <div className="prgmacc demand-section--3  m-t-30 m-b-60">
      <div key={key} className="row position-relative landing_swiper swipernavDetail mx-0">
        <Swiper
          // navigation={true}
          navigation={
            shouldShowNavigation()
              ? {
                  nextEl: `.swipernavDetail .swiper-button-next-${key}-00`,
                  prevEl: `.swipernavDetail .swiper-button-prev-${key}-00`
                }
              : false
          }
          pagination={
            window.innerWidth < 1050
              ? {
                  el: `.swiper-pagination-${key}`,
                  clickable: true,
                }
              : false
          }
          modules={[Pagination, Navigation, Autoplay]}
          spaceBetween={30}
          loop={false}
          containerModifierClass="w-100 "
          className="mySwiper"
          breakpoints={{
            1: {
              slidesPerView: 1.5,
              spaceBetween: 15
            },
            768: {
              slidesPerView: 2.5,
              spaceBetween: 20
            },
            1000: {
              slidesPerView: 4,
              spaceBetween: 20
            }
          }}
        >
          {programList.map((program, index) => (
            <SwiperSlide key={index} className="h-100">
              <div className="program-card d-flex flex-column h-100 bg-white rounded-lg overflow-hidden shadow-md">
                <div className=" cursor-pointer">
                  <img
                    className="media-object w-100 img-rounded img-fluid"
                    src={
                      program?.Program?.img
                        ? constand.S3_URL +
                          "/api/img/program/" +
                          program.Program.img
                        : constand.S3_URL + "/web/images/ondemand-placeholder.png"
                    }
                    alt="img"
                    onClick={() => navigateToProgram(program.Program)}
                  />
                </div>
                <div className="text-left card-content flex-grow-1 d-flex flex-column justify-content-between p-0 pt-3 cursor-pointer">
                  <h3
                    className="font-qsemibold black-txt-light font-16 capitalize_text fw600 mb-0"
                    onClick={() => navigateToProgram(program.Program)}
                  >
                    {program?.Program?.title}
                  </h3>
                  <p
                    className="font-14 font-qregular black-txt-light fw600 w-100 m-t-8 mb-8"
                    onClick={() => navigateToProgram(program.Program)}
                  >
                    {program?.Program?.formatDesc}
                  </p>
                </div>
                <div className="progress-percent pb-3 pr-1 pl-0 pt-0 border-0 cursor-pointer"  onClick={() => navigateToProgram(program.Program)}
                  >
                  <h2 className="font-12 gray-color fw500 font-qmedium text-left">
                  {program?.progressContent?.percentage < 100? "Your progress" : "Completed"}
                  </h2>
                  {program?.progressContent?.percentage < 100 && (
                      <div className="progress">
                        <div
                          className="progress-bar bg-c-red"
                          style={{
                            width: program?.progressContent?.percentage || 0,
                          }}
                        ></div>
                      </div>
                    )}
                  { program?.progressContent?.percentage >= 100 && (
                      <div className="progress bg-c-green">
                        <div
                          className="progress-bar bg-c-red"
                          style={{
                            width: program?.progressContent?.percentage || 0,
                          }}
                        ></div>
                      </div>
                    )}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className={`swiper-pagination swiper-pagination-${key} mt-3 text-center`}></div>
        {/* Navigation arrows (desktop only) */}
        {shouldShowNavigation() && (
          <>
          <div className={`swiper-button-prev-${key}-00 swiper-button-prev d-none d-md-block`}></div>
          <div className={`swiper-button-next-${key}-00 swiper-button-next d-none d-md-block`}></div>
          </>
        )}
      </div>
    </div>
  );
};

export default MyProgrammeAccordian;
